import React, { FC, useCallback, useState, useEffect } from "react";
import { useTask } from '../stateManagement/context';

import {
    ComponentTypeID,
    IControlMeasure, IControlMeasureCost, IDocument, IAssessmentSettings

} from "../types/types";

import NumberFormat from 'react-number-format';
import {
    Box,
    Chip,
    Collapse,
    Grid,
    IconButton,
    Input,
    InputAdornment, Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography, Button
} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Delete, Edit } from "@material-ui/icons";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Comments from "./comments";
import Documents from "./documents";
import { FormattedInput } from '@h-a-r-c/react-formatted-input';
import { Alert, AlertTitle } from "@material-ui/lab";


interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat<number> | null) => void;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}


function NumberFormatDollar(props: NumberFormatCustomProps) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="$"
        />
    );
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix=""
        />
    );
}

interface IControlMeasureCostProps {
    control_measure: IControlMeasure
    cm_c: IControlMeasureCost
    uControlMeasuresCost: (updateControlMeasuresCost: IControlMeasureCost) => void;
}



export const order_of_mag = (control_measure_cost: IControlMeasureCost): string => {
    const order_of_magnitute = [
        { limit: 1, label: "<1" },
        { limit: 2, label: "1-2" },
        { limit: 5, label: "2-5" },
        { limit: 10, label: "5-10" },
        { limit: 20, label: "10-20" },
        { limit: 50, label: "20-50" },
        { limit: 100, label: "50-100" },
        { limit: 1000000000, label: "> 100" },
    ]
    let cost = 0
    let op_before = 0
    let op_after = 0

    if (control_measure_cost.cost) {
        cost = control_measure_cost.cost
    }
    if (control_measure_cost.operating_cost_before) {
        op_before = control_measure_cost.operating_cost_before
    }
    if (control_measure_cost.operating_cost_after) {
        op_after = control_measure_cost.operating_cost_after
    }

    // NPV
    let years = 30
    let discount_rate = 0.07

    let NPV_op = 0
    for (let i = 0; i < years; i++) {
        let df = 1. / (1. + discount_rate) ** i
        NPV_op += df * (op_after - op_before)
    }

    let total_cost = cost + NPV_op

    let level = order_of_magnitute.length - 1
    for (let i = order_of_magnitute.length - 1; i > -1; i--) {
        if (total_cost / 1000000 > order_of_magnitute[i].limit) {
            break
        }
        level = i
    }
    return order_of_magnitute[level].label
}

export const CostAdequacy = (control_measure_cost: IControlMeasureCost) => {
    if (!control_measure_cost.cost_adequacy)
        return <>-</>

    let level = control_measure_cost.cost_adequacy.level

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1
    let level_text = "undefined"

    if (level === 4) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
        level_text = "Adequate";
    }
    if (level === 3) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
        level_text = "Adequate";
    }
    if (level === 2) {
        bcolor = "rgba(252,236,166," + alpha + ")";
        color = "rgb(152,96,34)";
    }
    if (level === 1) {
        bcolor = "rgba(251,84,81," + alpha + ")";
        color = "rgb(104,4,0)";
    }
    return (
        <Chip
            size="small"
            label={control_measure_cost.cost_adequacy.name}
            color="primary"
            style={{ backgroundColor: bcolor, color: color }}
        />)
}


function currencyFormat(num: number) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const ControlMeasureCost: FC<IControlMeasureCostProps> = ({
    control_measure,
    cm_c,
    uControlMeasuresCost
}) => {

    const [open, setOpen] = useState(false);

    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [current_control_measure, setControlMeasureCost] = useState<IControlMeasureCost>(cm_c)
    const [assessmentSettings, setAssessmentSettings] = useState<IAssessmentSettings>();
    const [customAssessmentSettings, setCustomAssessmentSettings] = useState<boolean>(false);



    let tasks = useTask()



    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    useEffect(() => {
        setControlMeasureCost(cm_c)

        if (cm_c.discount_rate)
            setCustomAssessmentSettings(true)
    }, [cm_c])

    useEffect(() => {
        if (tasks.loaded) {
            setAssessmentSettings(tasks.assessmentSettings)
        }
    }, [tasks.loaded, tasks.assessmentSettings])

    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }


    const handleCustomSettings = () => {

        let s = { ...assessmentSettings }
        let cost = { ...current_control_measure }
        cost.discount_rate = s.discount_rate
        cost.total_project_years = s.total_project_years
        cost.value_of_life = s.value_of_life
        setControlMeasureCost(cost)
        updateControlMeasuresCost(cost)
        setAreYouSure(false)

    }

    const [documentRef, setDocumentRef] = useState<IDocument>(() => {
        if (current_control_measure.document) {
            return current_control_measure.document
        }
        return {}
    }

    );


    const renderAreYouSure = () => {
        return (
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Use custom settings</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to use custom settings?

                            <Box mt={2}>
                                <Alert severity="warning">
                                    This will change the settings for this control measure. To change the dam wide settings, click the settings icon.
                                </Alert>
                            </Box>

                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleCustomSettings} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const updateControlMeasuresCost = (cm: IControlMeasureCost) => {
        let c = { ...cm };
        setControlMeasureCost(c)

        uControlMeasuresCost(c)
    }

    const updateDocumentSelection = useCallback((documentRef: IDocument) => {
        setDocumentRef(documentRef)
        setControlMeasureCost(prevState => {
            const updatedControlMeasure = { ...prevState };

            if (documentRef?.id) {
                updatedControlMeasure.document_id = documentRef.uuid;
                uControlMeasuresCost(updatedControlMeasure);
            }

            return updatedControlMeasure;
        });

    }, [setDocumentRef]);


    const createInputFieldNumber = (key: keyof IControlMeasureCost) => {
        return (
            <TextField
                id="standard-number"
                size={"small"}
                value={current_control_measure[key]}
                InputLabelProps={{
                    shrink: true,

                }}
                disabled={!write_access}

                InputProps={{
                    style: { fontSize: 14 },
                    inputComponent: NumberFormatCustom as any,
                }}
                onChange={(event) => {
                    let v = event.target.value
                    let numberValue = Number(v.replace(/[^0-9\.-]+/g, ""))
                    let c = { ...current_control_measure };
                    (c as any)[key] = numberValue
                    setControlMeasureCost(c)
                }}
                onBlur={
                    (event) => {
                        let v = event.target.value
                        let numberValue = Number(v.replace(/[^0-9\.-]+/g, ""))
                        let c = { ...current_control_measure };
                        (c as any)[key] = numberValue
                        setControlMeasureCost(c)
                        updateControlMeasuresCost(c)
                    }
                } />)
    }

    const createInputField = (key: keyof IControlMeasureCost, access: boolean = true) => {
        return (
            <TextField
                id="standard-number"
                size={"small"}
                disabled={!write_access || !access}
                value={current_control_measure[key]}
                InputLabelProps={{
                    shrink: true,

                }}

                InputProps={{
                    style: { fontSize: 14, textAlign: "right" },
                    inputComponent: NumberFormatDollar as any,
                }}
                onChange={(event) => {
                    let v = event.target.value
                    let numberValue = Number(v.replace(/[^0-9\.-]+/g, ""))
                    let c = { ...current_control_measure };
                    (c as any)[key] = numberValue
                    setControlMeasureCost(c)
                }}
                onBlur={
                    (event) => {
                        let v = event.target.value
                        let numberValue = Number(v.replace(/[^0-9\.-]+/g, ""))
                        let c = { ...current_control_measure };
                        (c as any)[key] = numberValue
                        setControlMeasureCost(c)
                        updateControlMeasuresCost(c)
                    }
                }
            />)
    }

    return (
        <>
            {renderAreYouSure()}
            <TableRow>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell><b>{control_measure.description}</b></TableCell>
                <TableCell>{order_of_mag(current_control_measure)}</TableCell>
                <TableCell>{createInputField("cost")}</TableCell>
                <TableCell
                    style={{ whiteSpace: "nowrap" }}>  {(current_control_measure.annualised_cost) ? "$ " + Number((current_control_measure.annualised_cost).toFixed(0)).toLocaleString() : "-"}</TableCell>
                <TableCell>{createInputFieldNumber("implementation_time")}</TableCell>

                <TableCell
                    style={{ whiteSpace: "nowrap" }}>{(current_control_measure.cssl) ? (current_control_measure.cssl) < 0 ? "< 0" : "$ " + Number((current_control_measure.cssl).toFixed(0)).toLocaleString() : "-"}</TableCell>
                <TableCell>{(current_control_measure.df) ? (current_control_measure.df) < 0 ? "< 0" : Number(current_control_measure.df.toFixed(0)).toLocaleString() : "-"}</TableCell>
                <TableCell>{CostAdequacy(current_control_measure)}</TableCell>
                <TableCell>{control_measure.uuid && <Comments parent_uuid={control_measure.uuid} type_id={ComponentTypeID.ControlMeasureCost} />}</TableCell>
                <TableCell style={{ width: 300 }}><Documents updateDocumentID={updateDocumentSelection} documentID={current_control_measure.document_id} showTitle={false} /></TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={1} />
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Grid container spacing={3}>
                                <Grid item xs={9}>

                                    <Table>
                                        <TableHead>
                                            <TableCell></TableCell>
                                            <TableCell>Societal Risk (Expected value)</TableCell>
                                            <TableCell>Individual Risk</TableCell>
                                            <TableCell>Economic Risk ($/yr)</TableCell>
                                            <TableCell>Safety Benefits($/yr)</TableCell>
                                            <TableCell>Operating Costs($/yr)</TableCell>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>before</TableCell>
                                                <TableCell>
                                                    <FormattedInput
                                                        obj={current_control_measure}
                                                        fieldKey={"societal_risk_before"}
                                                        format={"scientific"}
                                                        setObj={setControlMeasureCost}
                                                        updateObj={updateControlMeasuresCost}
                                                        write_access={write_access}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <FormattedInput
                                                        obj={current_control_measure}
                                                        fieldKey={"individual_risk_before"}
                                                        format={"scientific"}
                                                        setObj={setControlMeasureCost}
                                                        updateObj={updateControlMeasuresCost}
                                                        write_access={write_access}
                                                    />
                                                </TableCell>
                                                <TableCell>{createInputField("economic_risk_before")}</TableCell>
                                                <TableCell>{createInputField("public_benefits_before")}</TableCell>
                                                <TableCell>{createInputField("operating_cost_before")}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>after</TableCell>
                                                <TableCell>
                                                    <FormattedInput
                                                        obj={current_control_measure}
                                                        fieldKey={"societal_risk_after"}
                                                        format={"scientific"}
                                                        setObj={setControlMeasureCost}
                                                        updateObj={updateControlMeasuresCost}
                                                        write_access={write_access}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <FormattedInput
                                                        obj={current_control_measure}
                                                        fieldKey={"individual_risk_after"}
                                                        format={"scientific"}
                                                        setObj={setControlMeasureCost}
                                                        updateObj={updateControlMeasuresCost}
                                                        write_access={write_access}
                                                    />
                                                </TableCell>
                                                <TableCell>{createInputField("economic_risk_after")}</TableCell>
                                                <TableCell>{createInputField("public_benefits_after")}</TableCell>
                                                <TableCell>{createInputField("operating_cost_after")}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                                <Grid item xs={3}>


                                    <Table>
                                        <TableHead>

                                            <TableCell>Discount rate period</TableCell>
                                            <TableCell>Discount rate</TableCell>
                                            <TableCell>Value to prevent a fatality</TableCell>
                                            <TableCell>Fd</TableCell>
                                            <TableCell></TableCell>
                                        </TableHead>

                                        <TableBody>
                                            <>
                                                {customAssessmentSettings && <>
                                                    <TableCell>{createInputFieldNumber("total_project_years")}</TableCell>
                                                    <TableCell>{createInputFieldNumber("discount_rate")}</TableCell>
                                                    <TableCell>{createInputField("value_of_life")}</TableCell>
                                                    <TableCell>{cm_c.fd}</TableCell>
                                                </>}
                                                {!customAssessmentSettings && <>
                                                    <TableCell>{assessmentSettings?.total_project_years}</TableCell>
                                                    <TableCell>{((assessmentSettings?.discount_rate ?? 0)).toFixed(2)}</TableCell>
                                                    <TableCell>{currencyFormat(assessmentSettings?.value_of_life ?? 0)}</TableCell>
                                                    <TableCell>{cm_c.fd}</TableCell>
                                                    <TableCell>
                                                        {write_access && <><IconButton color="primary" aria-label="upload picture" component="span" style={{
                                                            color: "rgb(239,88,43)",

                                                        }} onClick={() => setAreYouSure(true)}>
                                                            <Edit />
                                                        </IconButton>


                                                        </>
                                                        }
                                                    </TableCell>
                                                </>

                                                }
                                            </>

                                        </TableBody>
                                    </Table>

                                    {customAssessmentSettings &&
                                        <Box mt={2}>
                                            <Alert severity="warning">
                                                Custom settings are used for this control measure.
                                            </Alert>
                                        </Box>}



                                </Grid>
                            </Grid>

                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>

    );
}

export default ControlMeasureCost;
